import { MOSAIC } from "./Tiles";

export const Marquee = ({ items, dark = false, className = "" }) => {
  const list = [...items, ...items];
  return (
    <div className={`relative overflow-hidden py-6 mask-fade-x ${dark ? "border-y border-white/10" : "border-y border-ink/10"} ${className}`} aria-label="Marchi dei mezzi a noleggio" data-testid="brand-marquee">
      <div className="flex w-max animate-marquee items-center gap-14 whitespace-nowrap sm:gap-20">
        {list.map((it, i) => (
          <span key={i} className="flex items-center gap-14 sm:gap-20">
            {it.src ? (
              <img
                src={it.src}
                alt={it.name}
                title={it.name}
                className={`h-6 w-auto object-contain transition-[filter,opacity] duration-500 sm:h-8 ${dark ? "brightness-0 invert opacity-60 hover:filter-none hover:opacity-100" : "brightness-0 opacity-50 hover:filter-none hover:opacity-100"}`}
                style={{ height: it.h }}
                loading="lazy"
                data-testid={`brand-logo-${it.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              />
            ) : (
              <span className={`font-display text-2xl font-black italic uppercase tracking-tight sm:text-3xl ${dark ? "text-white/60" : "text-ink/50"}`} data-testid={`brand-logo-${it.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                {it.name}
              </span>
            )}
            <span className="h-2 w-2" style={{ background: MOSAIC[i % MOSAIC.length] }} />
          </span>
        ))}
      </div>
    </div>
  );
};
